import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import PrivacyPage from "@/pages/PrivacyPage";
import PlanosPage from "@/pages/PlanosPage";
import ConfigPage from "@/pages/ConfigPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import ControleFinanceiro from "@/components/ControleFinanceiro";
import { ThemeProvider, useTheme } from "@/lib/ThemeContext";

function ThemedToaster() {
  const { theme } = useTheme();
  return (
    <Toaster
      theme={theme}
      position="bottom-center"
      toastOptions={{
        style: {
          background: "var(--surface-2)",
          border: "1px solid var(--border)",
          color: "var(--text)",
          fontFamily: "Sora",
        },
      }}
    />
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ThemedToaster />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacidade" element={<PrivacyPage />} />
          <Route path="/planos" element={<PlanosPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><ControleFinanceiro /></ProtectedRoute>} />
          <Route path="/configuracoes" element={<ProtectedRoute><ConfigPage /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
export default App;
